export const FETCH_ORDER_STATUSES = "FETCH_ORDER_STATUSES";
export const FETCH_ORDER_STATUS = "FETCH_ORDER_STATUS";

export function fetchOrderStatuses(params = {}) {
  params = Object.assign({}, { orderBy: "id:desc" }, params);
  return {
    type: FETCH_ORDER_STATUSES,
    auth: true,
    payload: {
      url: "resource/order-status",
      method: "GET",
      params,
    },
  };
}

export function fetchOrderStatus(id, params = {}) {
  return {
    type: FETCH_ORDER_STATUS,
    auth: true,
    payload: {
      url: `resource/order-status/${id}`,
      method: "GET",
      params,
    },
  };
}
